// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"69":"93e8d55d8477b0afc9c9","655":"b4284cbe71b1d07dcc1c"}[chunkId] + ".js";
};